<template>
  <div class="content-center">
    <div class="banner">
      <div class="title">汇通数科渠道合作伙伴火热招募中</div>
      <div class="desc" style="width: 600px;">开启新零售赛道掘金计划，打造区域明星品牌，携手合作共赢</div>
      <div class="btn" @click="goAnchor('#join')">立即加入</div>
    </div>
    <div class="sy_blocks" style="background-color: #ffffff;">
      <div class="sy_btitle">我们的产品</div>
      <div class="menu_content">
        <div class="menu_box">
          <div class="box_left">
            <p class="box_title">千橙零售云</p>
            <p class="box_title_text">零售门店数智化升级，助力经营增收提效</p>
            <div class="btn_content">
              <div class="menu_item" @click="linkTo('QcErpSystem')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf1.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">千橙ERP系统</p>
                  <p class="btn_text">到店/到家交易业务管理</p>
                </div>
              </div>
              <div class="menu_item" @click="linkTo('QcCashier')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf2.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">千橙收银系统</p>
                  <p class="btn_text">半自动/自助一体机收单</p>
                </div>
              </div>
              <div class="menu_item" @click="linkTo('QcChain')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf3.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">千橙连锁系统</p>
                  <p class="btn_text">支持直营/联营/加盟多业态</p>
                </div>
              </div>
              <div class="menu_item" @click="linkTo('QcShopkeeper')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf4.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">千橙新零售系统</p>
                  <p class="btn_text">门店O2O一体化综合管理</p>
                </div>
              </div>
              <div class="menu_item" @click="linkTo('QcAssociation')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf5.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">汇团团社群营销系统</p>
                  <p class="btn_text">社群团购分享小程序系统</p>
                </div>
              </div>
              <div class="menu_item" @click="linkTo('QcShoppingMall')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf6.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">千橙微商城系统</p>
                  <p class="btn_text">社群电商小程序系统</p>
                </div>
              </div>
              <div class="menu_item" @click="linkTo('QcMarketing')">
                <div class="item_left">
                  <img src="@/assets/images/home/2023/icon-cf7.png" alt="" />
                </div>
                <div class="item_right">
                  <p class="btn_title">千橙会员营销系统</p>
                  <p class="btn_text">基于会员的SCRM系统</p>
                </div>
              </div>
            </div>
          </div>
          <div class="box_right">
            <div class="right_item">
              <p class="box_title">千橙电商云</p>
              <p class="box_title_text">
                全链路电商能力覆盖，支持多种电商模式落地
              </p>
              <div class="btn_content">
                <div class="menu_item" @click="linkTo('QcCommerce')">
                  <div class="item_left">
                    <img src="@/assets/images/home/2023/icon-cf8.png" alt="" />
                  </div>
                  <div class="item_right">
                    <p class="btn_title">千橙电商S2B2C系统</p>
                    <p class="btn_text">全链路全闭环交易系统</p>
                  </div>
                </div>
                <div class="menu_item" @click="linkTo('QcB2BChannel')">
                  <div class="item_left">
                    <img src="@/assets/images/home/2023/icon-cf9.png" alt="" />
                  </div>
                  <div class="item_right">
                    <p class="btn_title">千橙电商B2b分销系统</p>
                    <p class="btn_text">批发渠道多层级分销系统</p>
                  </div>
                </div>
                <div class="menu_item" @click="linkTo('QcLiveBroadcast')">
                  <div class="item_left">
                    <img src="@/assets/images/home/2023/icon-cf10.png" alt="" />
                  </div>
                  <div class="item_right">
                    <p class="btn_title">汇好看直播系统</p>
                    <p class="btn_text">视频号+小程序直播系统</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="right_item">
              <p class="box_title">千橙服务云</p>
              <p class="box_title_text">AI+新场景，提升运营服务效率</p>
              <div class="btn_content">
                <div class="menu_item" @click="linkTo('QcTool')">
                  <div class="item_left">
                    <img src="@/assets/images/home/2023/icon-cf11.png" alt="" />
                  </div>
                  <div class="item_right">
                    <p class="btn_title">千橙RPA工具箱</p>
                    <p class="btn_text">机器人流程自动化服务</p>
                  </div>
                </div>
                <div class="menu_item" @click="linkTo('QcDigit')">
                  <div class="item_left">
                    <img src="@/assets/images/home/2023/icon-cf12.png" alt="" />
                  </div>
                  <div class="item_right">
                    <p class="btn_title">千橙数字人</p>
                    <p class="btn_text">AI数字人直播助手</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="right_item">
              <p class="box_title">千橙分销云</p>
              <p class="box_title_text">
                打造“连接” +“提效”+“交易”的一站式智能分销平台
              </p>
              <div class="btn_content">
                <div class="menu_item" @click="linkTo('QcDistribution')">
                  <div class="item_left">
                    <img src="@/assets/images/home/2023/icon-cf13.png" alt="" />
                  </div>
                  <div class="item_right">
                    <p class="btn_title">千橙分销</p>
                    <p class="btn_text">基于企微的业务员分销系统</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sy_blocks gray">
      <div class="sy_btitle">服务商收益模型</div>
      <div class="sy_bimg">
        <img src="../../assets/images/cp1.png" />
      </div>
    </div>
    <div class="sy_blocks" style="background-color: #ffffff;">
      <div class="sy_btitle">我们对服务商的赋能</div>
      <div class="sy_bsubtitle">十大保障体系，快速起步</div>
      <div class="sy_bimg">
        <img src="../../assets/images/cp2.png" />
      </div>
    </div>
    <div class="serviceProvider">
      <div class="sk-block-title">
        <div class="title">我们需要这样的服务商合作伙伴</div>
      </div>
      <div class="content">
        <img src="@/assets/images/cp3.png" alt="" />
        <img style="width:590px;" src="@/assets/images/cp4.png" alt="" />
      </div>
    </div>
    <div id="join" class="join">
      <div class="title">渠道合作商 期待您的加入</div>
      <img src="@/assets/images/cooperate/cooperate_process.png" alt="" />
      <a-form
        :form="form"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
        colon
        hide-required-mark
        class="form"
        @submit="handleSubmit"
      >
        <div class="formItem">
          <a-form-item label="公司名称">
            <a-input
              v-decorator="[
                'company',
                { rules: [{ required: true, message: '请输入公司名称!' }] },
              ]"
              placeholder="必填，公司名称与营业执照一致"
            />
          </a-form-item>
        </div>
        <a-form-item label="联系人">
          <a-input
            v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入联系人姓名!' }] },
            ]"
            placeholder="必填，联系人姓名"
          />
        </a-form-item>
        <a-form-item
          label="联系电话"
          :validate-status="userError() ? 'error' : ''"
          :help="userError() || ''"
        >
          <a-row :gutter="20">
            <a-col :span="12">
              <a-input
                v-decorator="[
                  'phone',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请输入手机号!',
                      },
                      {
                        validator: checktelphone,
                      },
                    ],
                  },
                ]"
                placeholder="必填，联系人电话"
              />
            </a-col>
            <a-col :span="12">
              <a-input-search
                v-decorator="[
                  'verifyCode',
                  { rules: [{ required: true, message: '请输入短信验证码!' }] },
                ]"
                placeholder="短信验证码"
                size="large"
                @search="getVerificationCode"
              >
                <a-button slot="enterButton" :disabled="!isShowGetCode">
                  <template v-if="isShowGetCode">获取验证码</template>
                  <template v-else>{{ countdown }}s后可重试</template>
                </a-button>
              </a-input-search>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="所在城市">
          <a-input
            v-decorator="[
              'address',
              { rules: [{ required: true, message: '请输入所在城市!' }] },
            ]"
            placeholder="请输入所在城市"
          />
        </a-form-item>
        <a-form-item label="目前行业">
          <a-input
            v-decorator="[
              'industry',
              { rules: [{ required: true, message: '请输入行业!' }] },
            ]"
            placeholder="请输入行业"
          />
        </a-form-item>
        <a-form-item label="合作意向">
          <a-input
            v-decorator="['informationExplain']"
            :style="{
              height: '100px',
            }"
            type="textarea"
            placeholder="请将您的合作需求或建议反馈给我们"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 8 }">
          <a-button type="primary" html-type="submit" class="submit-btn">
            信息提交
          </a-button>
        </a-form-item>
      </a-form>
      <div id="captcha" />
    </div>
  </div>
</template>

<script>
import metaInfo from "@/common/util/metaInfo";
import { sendSmsCaptcha, informationCollection } from "@/apis/index";

export default {
  metaInfo: metaInfo.Cooperate,
  data() {
    return {
      form: this.$form.createForm(this),
      captcha: null,
      countdown: 60,
      timer: "",
      isShowGetCode: true,
      captchaIns: null,
      params: null,
    };
  },
  mounted() {
    this.getCode();
  },
  methods: {
    linkTo(path) {
      if (!path.startsWith("/")) {
        path = "/" + path;
      }
      this.$router.push({ path });
      browseCount();
    },
    userError() {
      const { getFieldError } = this.form;
      return getFieldError("phone") || getFieldError("verifyCode");
    },
    checktelphone(rule, value, callback) {
      const reg = /^1[3456789]\d{9}$/;
      if (value && !reg.test(value)) {
        callback("请输入正确的手机号码！");
      } else {
        callback();
      }
    },
    // 模拟锚点跳转
    goAnchor(selector) {
      // 参数selector是id选择器（#anchor14）
      document.querySelector(selector).scrollIntoView({
        behavior: "smooth",
      });
    },
    getVerificationCode() {
      this.form.validateFields(["phone"], (errors, values) => {
        if (!errors) {
          this.params = values;
          this.captchaIns.popUp();
        }
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            infoSources: "汇通数科官网-渠道合作",
            officialWebsiteEntrance: "PC",
            address: values.address,
            name: values.name,
            phone: values.phone,
            verifyCode: values.verifyCode,
            company: values.company,
            industry: values.industry,
            informationExplain: values.informationExplain,
          };
          informationCollection(params)
            .then((res) => {
              this.$message.success({
                content: "感谢您的信息提交，我们将会有专员与您联系~",
                duration: 1,
              });
              this.captchaIns.refresh();
              this.form.resetFields();
            })
            .catch((err) => {
              this.$message.error(err);
              this.captchaIns.refresh();
            });
        }
      });
    },
    countDown() {
      const self = this;
      this.timer = setInterval(() => {
        self.countdown--;
        if (self.countdown === 0) {
          clearInterval(self.timer);
          self.countdown = 60;
          self.isShowGetCode = true;
          self.captchaIns.refresh();
        }
      }, 1000);
    },
    getCode() {
      const that = this;
      // eslint-disable-next-line no-undef
      initNECaptcha &&
        initNECaptcha(
          {
            element: "#captcha",
            captchaId: "6c0483e901164a789d9d13f0291ba257",
            mode: "popup",
            width: "320px",
            // enableClose: true,
            onClose: function () {
              // 弹出关闭结束后将会触发该函数
            },
            onVerify: function (err, data) {
              if (err) return;
              // that.captchaIns.close()
              that.params.pictureCode = data.validate;
              sendSmsCaptcha(that.params)
                .then((data) => {
                  that.countDown();
                  that.isShowGetCode = false;
                })
                .catch((err) => {
                  that.$message.error(err);
                  that.captchaIns.refresh();
                });
            },
          },
          function (instance) {
            // 初始化成功后得到验证实例instance，可以调用实例的方法
            that.captchaIns = instance;
          },
          function (err) {
            console.log(err);
            // 初始化失败后触发该函数，err对象描述当前错误信息
          }
        );
    },
  },
};
</script>

<style lang="less" scoped>
.menu_content {
  margin-top: 40px;
  width: 1200px;
  height: 548px;
  .menu_box {
    width: 1200px;
    height: 548px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .box_title {
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 33px;
      margin-bottom: 0px;
      text-align: left;
    }
    .box_title_text {
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-top: 4px;
      margin-bottom: 0px;
      text-align: left;
    }
    .box_left {
      width: 497px;
      height: 546px;
      background: url("~@/assets/images/home/2023/menuBanner1.png") no-repeat
        center;
      background-size: 100% 100%;
      padding: 20px;
      .btn_content {
        width: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-top: 18px;
        .menu_item {
          width: 192px;
          height: 56px;
          background: #ffffff;
          border-radius: 3px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          padding: 11px 10px;
          margin-right: 30px;
          margin-bottom: 25px;
          cursor: pointer;
          .item_left {
            width: 20px;
            img {
              width: 20px;
              height: 20px;
            }
          }
          .item_right {
            flex: 1;
            padding-left: 5px;
            .btn_title {
              height: 20px;
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              color: #333333;
              line-height: 20px;
              margin-bottom: 0px;
              text-align: left;
            }
            .btn_text {
              height: 14px;
              font-size: 10px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 14px;
              margin-bottom: 0px;
              text-align: left;
            }
          }
        }
      }
    }
    .box_right {
      width: 662px;
      height: 546px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .right_item {
        padding: 20px 0 0 20px;
        width: 662px;
        height: 172px;
        background: url("~@/assets/images/home/2023/menuBanner2.png") no-repeat
          center;
        background-size: 100% 100%;
        .btn_content {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          margin-top: 18px;
          flex-wrap: wrap;
          .menu_item {
            width: 192px;
            height: 56px;
            background: #ffffff;
            border-radius: 3px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            padding: 11px 10px;
            margin-right: 16px;
            cursor: pointer;
            .item_left {
              width: 20px;
              img {
                width: 20px;
                height: 20px;
              }
            }
            .item_right {
              flex: 1;
              padding-left: 5px;
              .btn_title {
                height: 20px;
                font-size: 14px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 20px;
                margin-bottom: 0px;
                text-align: left;
              }
              .btn_text {
                height: 14px;
                font-size: 10px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 14px;
                margin-bottom: 0px;
                text-align: left;
              }
            }
          }
        }
      }
    }
  }
}
.sy_blocks {
  overflow: hidden;
  padding-top: 60px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.sy_blocks.gray {
  background: linear-gradient(180deg, #fdfdfd 0%, #fafafa 100%);
}
.sy_btitle {
  height: auto;
  font-size: 36px;
  font-weight: 500;
  color: #333333;
  line-height: 40px;
  text-align: center;
}
.sy_bsubtitle {
  height: auto;
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  text-align: center;
  margin-top: 15px;
}
.sy_bimg {
  width: 1200px;
  margin: 0 auto;
  margin-top: 45px;
  img{
    width:1200px;
  }
}
.banner {
  padding: 80px 0 57px;
  background: url("~@/assets/images/cooperate/cooperate_banner-bg.png")
    no-repeat center;

  .title {
    font-size: 48px;
    color: #ffffff;
    line-height: 46px;
    text-shadow: 0px 2px 4px rgba(14, 15, 120, 0.17);
  }

  .desc {
    width: 577px;
    height: 118px;
    margin: 0 auto;
    font-size: 22px;
    color: #ffffff;
    line-height: 28px;
    text-shadow: 0px 2px 4px rgba(15, 23, 135, 0.29);
    padding-top: 40px;
  }

  .btn {
    width: 234px;
    height: 48px;
    border-radius: 6px;
    border: 1px solid #ffffff;
    font-size: 23px;
    font-weight: 400;
    color: #ffffff;
    line-height: 48px;
    text-align: center;
    margin: 0px auto 0;
  }
}

.spread {
  padding-bottom: 62px;

  .content {
    width: 1200px;
    margin: 79px auto 0;
    display: flex;
    justify-content: space-between;

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;

      span {
        font-size: 20px;
        padding-top: 50px;
      }
    }
  }
}

.model {
  background: #fafafa;
}

.enable {
  padding-bottom: 20px;

  .content {
    width: 1187px;
    height: 627px;
    margin: 54px auto 0;
    background: url("~@/assets/images/cooperate/cooperate_enable-bg.png")
      no-repeat center;
  }
}

.serviceProvider {
  background: #fafafa;
  padding-bottom: 44px;

  .content {
    width: 1224px;
    margin: 50px auto 0;
  }
}

.join {
  height: 910px;
  overflow: hidden;
  background: url("~@/assets/images/cooperate/cooperate_form-bg.png") no-repeat;
  padding: 71px 0 63px;

  .form {
    width: 800px;
    margin: 60px auto 0;
    font-size: 18px;
    transform: translateX(-61px);

    .label {
      font-size: 20px;
      font-weight: 400;
      color: #ffffff;
      line-height: 28px;
      text-align: right;
      padding: 7px 7px 0;
    }

    /deep/ .ant-input {
      height: 50px;
      font-size: 20px;
    }

    /deep/ .ant-btn-lg {
      height: 50px;
      font-size: 20px;
      color: #ff7700;
      background: #f9fbfd;
    }

    /deep/ .ant-select-selection--single {
      height: 50px;
    }

    /deep/ .ant-select-selection__rendered {
      line-height: 50px;
      font-size: 20px;
    }

    /deep/ .ant-form-item-label {
      line-height: 50px;
    }

    /deep/ .ant-form-item-label > label {
      color: #fff;
      font-size: 20px;
    }

    /deep/ .ant-btn {
      height: 50px;
    }

    .submit-btn {
      width: 400px;
      height: 50px;
      background: #ff8c24;
      border-radius: 35px;
      font-size: 20px;
      font-weight: 500;
      color: #ffffff;
      line-height: 40px;
      border: transparent;
    }
  }

  .title {
    font-size: 36px;
    font-weight: 500;
    color: #ffffff;
    line-height: 50px;
  }

  img {
    display: block;
    margin: 38px auto 58px;
  }

  .imgCaptcha {
    display: inline-block;
    margin: 0;
    height: 50px;
    margin-left: 10px;
  }

  .reload {
    color: #ff7700;
    font-size: 18px;
    cursor: pointer;
    line-height: 50px;
    margin-left: 20px;
  }

  .captcha-wapper {
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    justify-content: space-around;
  }
}
</style>
